import { SET_IS_DISABLED_EDITION } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (value) => panelLayoutV2Actions[SET_IS_DISABLED_EDITION](value);
